import { ApolloProvider } from '@apollo/client';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import * as Integrations from '@sentry/browser';
import * as Sentry from '@sentry/react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Footer from '../components/Footer';
import { CurrentUserProvider } from '../contexts/CurrentUserContext';
import { FeatureFlagsProvider } from '../contexts/FeatureFlagsContext';
import { OAuth2Provider } from '../contexts/OAuth2Context';
import { SnackbarProvider } from '../contexts/SnackbarContext';
import { TutorialProvider } from '../contexts/TutorialContext';
import { createClient } from '../utils/apollo';
import { AppRoutes } from '../utils/routes';
import theme from '../utils/theme';

const App = () => {
  if (process.env.APP_ENV !== 'dev') {
    Sentry.init({
      dsn: 'https://bebe9ddb38fc4e56971bd65f3b76f5b3@o1101134.ingest.sentry.io/6126882',
      environment: process.env.APP_ENV,
      integrations: [Integrations.browserTracingIntegration()],
      tracesSampleRate: 1.0,
    });
  }

  return (
    <ApolloProvider client={createClient()}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Router>
            <OAuth2Provider>
              <CurrentUserProvider>
                <SnackbarProvider>
                  <FeatureFlagsProvider>
                    <TutorialProvider>
                      <AppRoutes />
                    </TutorialProvider>
                  </FeatureFlagsProvider>
                </SnackbarProvider>
              </CurrentUserProvider>
            </OAuth2Provider>
            <Footer />
          </Router>
        </ThemeProvider>
      </StyledEngineProvider>
    </ApolloProvider>
  );
};

render(<App />, document.querySelector('#root'));
